import React from 'react';

const UseCase = ({ isActive, icon, title, subtitle, cards, metrics, metricsTitle }) => {
  if (!isActive) return null;

  return (
    <section className="usecase-container active">
      <div className="container">
        <div className="usecase-header">
          <div className="usecase-icon">{icon}</div>
          <h2>{title}</h2>
          <p>{subtitle}</p>
        </div>

        <div className="usecase-content">
          {cards.map((card, index) => (
            <div key={index} className="usecase-card">
              <h3>{card.title}</h3>
              <div className="example">{card.example}</div>
              <div className="result">{card.result}</div>
              <div className="vs">{card.vs}</div>
            </div>
          ))}
        </div>

        <div className="comparison-section">
          <div className="comparison-header">
            <h3>{metricsTitle}</h3>
          </div>
          <div className="comparison-grid">
            {metrics.map((metric, index) => (
              <div key={index} className="comparison-item">
                <div className="metric">{metric.label}</div>
                <div className="value">{metric.value}</div>
                <div className="description">{metric.description}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="cta-buttons">
          <button
            className="btn-primary"
            onClick={() => alert('Starting free trial...')}
          >
            Start Free Trial
          </button>
          <button
            className="btn-secondary"
            onClick={() => alert('Watching demo...')}
          >
            Watch Demo
          </button>
        </div>
      </div>
    </section>
  );
};

export default UseCase;
